import { SystemConfig } from '~/Types/SystemConfig';

export enum APIHosts {
  Identity = 'identityServerUrl',
  LicenseManager = 'licenseManagerUrl',
}

export class ApiHelpers {
  config = {} as SystemConfig;

  getHost = (apiHost: APIHosts): string => {
    if (!this.config[apiHost]) {
      return '';
    }
    return this.config[apiHost];
  };

  setConfig = (config: SystemConfig): this => {
    this.config = config;
    return this;
  };
}

